export default __webpack_public_path__ + "static/media/sound_effect.4147fb5a.png";